import { ngRoute } from '../../../app/routing/ngRoute.ts';
import { clone } from 'lodash';

export default {
    bindings: {
        setCustomContent: '<',
        setHierarchicalNav: '<',
    },
    template: `
        <ng-container ng-if="$ctrl.data">
            <dashboard-page 
                data="$ctrl.data" 
                set-custom-content="$ctrl.setCustomContent" 
                set-hierarchical-nav="$ctrl.setHierarchicalNav">
            </dashboard-page>
        </ng-container>
    `,
    controller: [
        'snapshotLoadService',
        'currentUser',
        'newDashboardService',
        'dashboardV2Service',
        function (snapshotLoadService, currentUser, newDashboardService, dashboardV2Service) {
            const $ctrl = this;
            const fetchDashboardSnapshotData = () => {
                const snapshotId = ngRoute.params.snapshotID;
                return snapshotLoadService(snapshotId).then(function (snapshot) {
                    if (!snapshot) {
                        return {};
                    }

                    const data = clone(snapshot.payload);
                    if (snapshot.type === 'Chart') {
                        ngRoute.history?.replace(`/temp/chart/${snapshot.id}`);
                        return;
                    }

                    currentUser.orgPreferences().then(function (prefs) {
                        // Unlikely that the user will know the snapshot id after the new
                        // dashboard has been modified, since the id changes after each
                        // edit, but just in case...
                        if (prefs.sf_newDashboard === snapshotId) {
                            const update = {
                                sf_numUnseenCharts: 0,
                            };
                            newDashboardService.updateNewDashboardInfo(update);
                        }
                    });
                    data.dashboard = dashboardV2Service.apiDashboardToUI(data.dashboard);
                    const dashboard = clone(data.dashboard);
                    return {
                        dashboard: dashboard,
                        alldashboards: [data.dashboard],
                        charts: data.charts,
                        snapshot: {
                            id: snapshot.id,
                            type: snapshot.type,
                            sourceId: snapshot.sourceId,
                            expiryMs: snapshot.expiryMs,
                            creator: snapshot.creator,
                            created: snapshot.created,
                            lastUpdatedBy: snapshot.lastUpdatedBy,
                            lastUpdated: snapshot.lastUpdated,
                            payload: snapshot.payload,
                            sender: snapshot.payload.originalSender || snapshot.sender,
                        },
                    };
                });
            };

            $ctrl.$onInit = function () {
                fetchDashboardSnapshotData().then((data) => {
                    $ctrl.data = data;
                });
            };
        },
    ],
};
